import { render } from "./search-template.vue?vue&type=template&id=ad69cec8&external"
import script from "./companies-index.vue?vue&type=script&lang=js"
export * from "./companies-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__